import { useTranslation } from "react-i18next";
import "moment-timezone";
import { useEffect, useRef, useState } from "react";
import { SwalAlertClass } from "core/swalClass";
import { arrayChoicesToObject } from "views/utils/MutateValues";
import Moment from "moment/moment";
import axiApi from "ApiCaller";
import { Link } from "react-router-dom";

const TableAlertsWaste = () => {
  const { t } = useTranslation("tables");
  const { t: _Tc } = useTranslation("choices");
  const [items, setItems] = useState([]);
  const wastes = useRef({});
  const downloads = useRef({});
  const types = useRef({});

  useEffect(() => {
    axiApi
      .get(`/api/home/alerts/`)
      .then((resp) => {
        if (resp.data.status) {
          wastes.current = arrayChoicesToObject(resp.data.params.filters.waste);
          downloads.current = arrayChoicesToObject(
            resp.data.params.filters.download
          );
          types.current = arrayChoicesToObject(resp.data.params.filters.type);
          console.log(resp.data.items);
          setItems(resp.data.items);
        }
      })
      .catch((error) => {
        console.error("Error al enviar la solicitud:", error);
      });
  }, []);

  return (
    <>
      <div className="col-12">
        <table className="table table-striped">
          <thead className="table-light">
            <tr>
              <th>{t("alerts.alarm_type")}</th>
              <th>{t("alerts.waste_uuid")}</th>
              <th>{t("alerts.device_uuid")}</th>
              <th>{t("alerts.device_island")}</th>
              {/* <th>{t("alerts.routes")}</th> */}
              <th>{t("routes.download_type")}</th>
              <th>{t("alerts.value")}</th>
              <th>{t("alerts.resolved_at")}</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index} data-idx={index}>
                <td>{_Tc("alerts_types." + item.type)}</td>
                <td>
                  {item.waste_uuid ? (
                    <Link
                      to={`/data-view/data-container/${item.waste_uuid}/`}
                      className="slx-link"
                    >
                      {item.waste_uuid}
                    </Link>
                  ) : (
                    "-"
                  )}
                </td>

                <td>{item.device_uuid}</td>
                <td>{item.device_island}</td>
                <td>{_Tc("downloads." + item.download_type)}</td>
                <td>{item.type === "sm" ? "-" : item.value}</td>
                <td>
                  {item.resolved_at && Moment(item.resolved_at).isValid()
                    ? Moment(item.resolved_at).format("DD/MM/YYYY HH:mm:ss")
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TableAlertsWaste;
